import { CoordinatorService } from './coordinator.service';
import { ValueItemField } from './value-item-field';

export type VIPAR = {
    id?: string;
    itemId: string;
    templateId: string;
    ownerId: string;
    tableLs?: any[];
};
export class ValueItem {
    id: string;
    itemId: string;
    templateId: string;
    ownerId: string;
    private _tableLs: any[] = [];

    // private _valueItemMap = new Map<string, any[]>();

    constructor(
        public coords: CoordinatorService,
        { id, itemId, templateId, ownerId, tableLs }: VIPAR,
    ) {
        this.id = id || this.coords.uniqueId();
        this.itemId = itemId;
        this.templateId = templateId;

        this.coords.user$.currentId &&
            (!ownerId || ownerId === '_unlogged') &&
            (ownerId = this.coords.user$.currentId);
        this.ownerId = ownerId;

        tableLs?.forEach((fLs) => {
            this._tableLs.push(new Map<string, any>(fLs));
        });
    }

    getField(k: string[]) {
        const template = this.coords.valueItem$.getTemplate(this.templateId);
        if (!template) return [];
        const tpl = k.slice(0, 2);
        const fK = tpl.pop();
        if (tpl.length && tpl[0] !== template.title.toLowerCase()) return [];
        const respLs: any[] = [];

        for (let f of template.fieldLs) {
            if (f.title.toLowerCase() !== fK) continue;
            this._tableLs.forEach((mp) => {
                const v = mp.get(f.id);
                if (v === undefined) return;
                switch (f.kind) {
                    case 'value':
                        respLs.push(v);
                        break;
                    case 'choice':
                        const chV = f.choiceLs?.find((ch) => ch.id === v[0])?.label;
                        chV && respLs.push(chV);
                        break;
                    case 'multichoice':
                        const mV = f.choiceLs
                            ?.filter((ch) => v.includes(ch.id))
                            .map((ch) => ch.label);
                        mV && respLs.push(...mV);
                        break;
                }
            });
        }
        return respLs;
    }

    get tableLs() {
        if (!this._tableLs.length) this.addTable();
        return Array.from(this._tableLs);
    }

    get scriptTableLs() {
        const template = this.coords.valueItem$.getTemplate(this.templateId);
        if (!template) return [];
        const fieldMap = new Map(template.fieldLs.map((f) => [f.id, f]));
        const ls: any[] = [];
        this._tableLs.forEach((mp: Map<string, any>) => {
            const r: Record<string, any> = {};
            ls.push(r);
            mp.forEach((value, key) => {
                let f = fieldMap.get(key);
                if (!f) return;
                switch (f.kind) {
                    case 'value':
                        r[f.title] = value;
                        break;
                    case 'choice':
                        r[f.title] = f.choiceLs?.find((ch) => ch.id === value[0])?.label;
                        break;
                    case 'multichoice':
                        r[f.title] = f.choiceLs
                            ?.filter((ch) => value.includes(ch.id))
                            .map((ch) => ch.label);

                        break;
                }
            });
        });

        return ls;
    }

    hasValue(f: ValueItemField) {
        for (let mp of this._tableLs) {
            if (mp.has(f.id)) return true;
        }
        return false;
    }

    getValue(f: ValueItemField, position: number) {
        let mp = this._tableLs[position];
        return mp?.get(f.id);
    }
    setValue(f: ValueItemField, v: any, position: number) {
        let mp = this._tableLs[position];
        if (!mp) {
            mp = new Map<string, any>();
            this._tableLs[position] = mp;
        }

        mp.set(f.id, v);
        this.coords.valueItem$.storeValueItem(this);
    }

    save() {
        return {
            id: this.id,
            itemId: this.itemId,
            templateId: this.templateId,
            ownerId: this.ownerId,
            tableLs: this._tableLs.map((mp) => Array.from(mp.entries())),
        };
    }

    addTable() {
        this._tableLs.push(new Map<string, any>());
    }
}
